import { render, staticRenderFns } from "./product-selector-dialog.app.vue?vue&type=template&id=6aa1d140&"
import script from "./product-selector-dialog.app.vue?vue&type=script&lang=js&"
export * from "./product-selector-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports